import React from 'react';
import DataTable from '../Components/DataTable';
import StatusBadge from '../Components/StatusBadge';
import FormattedDate from '../Components/FormattedDate';

function TablaPromociones({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, ...props }) {
    const { promociones = [] } = props;

    const columns = [
        {
            Header: 'ID',
            accessor: 'IdPromocion',
        },
        {
            Header: 'Título',
            accessor: 'Titulo',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px', fontWeight: '500' }}>
                    {value && value.length > 30 ? `${value.substring(0, 30)}...` : value}
                </div>
            )
        },
        {
            Header: 'Imagen',
            accessor: 'Url_File',
            Cell: ({ value }) => (
                <img 
                    src={value || '/favicon.png'} 
                    alt="Promoción" 
                    className="avatar"
                    style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '6px' }}
                    onError={(e) => {
                        e.target.src = '/favicon.png';
                    }}
                />
            )
        },
        {
            Header: 'Descuento',
            accessor: 'Valor_descuento',
            Cell: ({ value }) => (
                <span style={{ 
                    background: '#e3f2fd', 
                    color: '#1565c0', 
                    padding: '4px 8px', 
                    borderRadius: '12px', 
                    fontSize: '12px', 
                    fontWeight: '600' 
                }}>
                    {value}%
                </span>
            )
        },
        {
            Header: 'Fechas',
            accessor: 'Fecha_inicio',
            Cell: ({ row }) => (
                <div style={{ fontSize: '12px' }}>
                    <div><strong>Inicio:</strong> <FormattedDate date={row.original.Fecha_inicio} format="DD/MM/YYYY" /></div>
                    <div><strong>Fin:</strong> <FormattedDate date={row.original.Fecha_fin} format="DD/MM/YYYY" /></div>
                </div>
            )
        },
        {
            Header: 'Duración',
            accessor: 'DuracionDias',
            Cell: ({ value }) => (
                <span style={{ fontSize: '12px' }}>
                    {value} {value === 1 ? 'día' : 'días'}
                </span>
            )
        },
        {
            Header: 'Ubicación',
            accessor: 'Ubicacion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '150px' }}>
                    {value && value.length > 20 ? `${value.substring(0, 20)}...` : value}
                </div>
            )
        },
        {
            Header: 'Estado',
            accessor: 'EstatusActual',
            Cell: ({ value }) => <StatusBadge status={value} />
        },
        {
            Header: 'Descripción',
            accessor: 'Descripcion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px', fontSize: '12px' }}>
                    {value && value.length > 50 ? `${value.substring(0, 50)}...` : value}
                </div>
            )
        }
    ];

    return (
        <DataTable
            data={promociones}
            columns={columns}
            idField="IdPromocion"
            onSelectionChange={onSelectionChange}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="Datos no encontrados"
            className="tabla-promociones"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaPromociones;